import { useState, useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Loader from "../Loader";

import { ReactComponent as FacebookIcon } from "../../static/images/facebook.svg";

import "./style.scss";

export const FacebookLoginBtn = () => {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const queryParams = Object.fromEntries([...params]);
  const { pathname, state } = useLocation();

  const [loading, setLoading] = useState(false);
  const [sdkLoaded, setSdkLoaded] = useState(false);

  useEffect(() => {
    // Check if Facebook SDK is loaded
    const checkFacebookSDK = () => {
      if (window.FB) {
        setSdkLoaded(true);
      } else {
        // Retry after a short delay
        setTimeout(checkFacebookSDK, 100);
      }
    };

    checkFacebookSDK();
  }, []);

  const redirectToFacebook = () => {
    setLoading(true);
    const isProviderRegiterPage = pathname === "/register";
    const isConsumerRegiterPage = pathname === "/signUp";
    const authType = isProviderRegiterPage
      ? "register-provider"
      : isConsumerRegiterPage
        ? "register-consumer"
        : "login";
    const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;
    const REDIRECT_URI = encodeURIComponent(
      `${window.location.origin}/facebook-callback/${authType}`,
    );
    const encodedState = encodeURIComponent(
      JSON.stringify({
        invitationId: queryParams.invitationId,
        email: queryParams.email,
        phoneNumber: queryParams.phoneNumber,
        pricePlan: queryParams.pricePlan,
        afterLoginUrl: state?.from?.pathname,
      }),
    );
    const SCOPES = "email,public_profile";
    const fbUrl = `https://m.facebook.com/v22.0/dialog/oauth?client_id=${FACEBOOK_APP_ID}&redirect_uri=${REDIRECT_URI}&response_type=token&scope=${SCOPES}&state=${encodedState}`;
    window.location.href = fbUrl;
  };

  return (
    <>
      {loading && <Loader />}
      <button
        onClick={redirectToFacebook}
        disabled={!sdkLoaded}
        className="fb-login-btn"
      >
        <FacebookIcon />
        <span>{t("continue_facebook")}</span>
      </button>
    </>
  );
};
